import { ICodeTaskDTO } from '../lib/interfaces/CodeTask';
import { CommentDTO, Comment } from '../lib/interfaces/Comment';
import { Course } from '../lib/interfaces/Course';
import { IOrder } from '../lib/interfaces/Order';
// import { IProduct } from '../lib/interfaces/Product';
import { RecoverPasswordDTO } from '../lib/interfaces/RecoverPasswordDTO';
import { Task } from '../lib/interfaces/Task';
import {
	UserDTO,
	UserGoogleLogin,
	UserRegistrationDTO,
} from '../lib/interfaces/User';
import { endpoints } from './endpointBuilder';
import { axiosRequest } from './request';

// USER

export const login = async (data: UserDTO) =>
	axiosRequest(endpoints.auth.getLoginApi(data));

export const googleLogin = async (data: UserGoogleLogin) =>
	axiosRequest(endpoints.auth.getGoogleLoginApi(data));

export const registration = async (data: UserRegistrationDTO) =>
	axiosRequest(endpoints.auth.getRegistrationApi(data));

export const activateUser = async (token: string) =>
	axiosRequest(endpoints.auth.activateUser(token));

export const resendUserActivation = async () =>
	axiosRequest(endpoints.auth.resendUserActivation());

export const getUserMe = async () => axiosRequest(endpoints.auth.getUserMe());

export const forgotPassword = async (email: string) =>
	axiosRequest(endpoints.auth.forgotPassword(email));

export const recoveryPassword = async (data: RecoverPasswordDTO) =>
	axiosRequest(endpoints.auth.recoveryPassword(data));

// COURSE

export const getCourses = async (occupation: string) =>
	axiosRequest(endpoints.courses.getCourses(occupation));

export const getCourseBySlug = async (slug: string) =>
	axiosRequest(endpoints.courses.getCourseBySlug(slug));

export const createCourse = async (data: Course) =>
	axiosRequest(endpoints.courses.createCourse(data));

export const updateCourse = async (data: Course, id: number | undefined) =>
	axiosRequest(endpoints.courses.updateCourse(data, id));

// TASK

export const getTaskBySlug = async (slug: string) =>
	axiosRequest(endpoints.tasks.getTaskById(slug));

export const createTask = async (data: Task) =>
	axiosRequest(endpoints.tasks.createTask(data));

export const updateTask = async (data: Task, id: number | undefined) =>
	axiosRequest(endpoints.tasks.updateTask(data, id));

export const toggleCompleteTask = async (taskId: number) =>
	axiosRequest(endpoints.tasks.toggleCompleteTask(taskId));

// COMMENTS

export const getTaskComments = async (id: number) =>
	axiosRequest(endpoints.comments.getTaskComments(id));

export const createComment = async (
	data: CommentDTO,
	id: number,
): Promise<Comment> => axiosRequest(endpoints.comments.createComment(data, id));

export const updateComment = async (
	data: CommentDTO,
	id: number,
): Promise<Comment> => axiosRequest(endpoints.comments.updateComment(data, id));

export const replyToComment = async (
	data: CommentDTO,
	id: number,
	commentId?: number,
): Promise<Comment> =>
	axiosRequest(endpoints.comments.replyComment(data, id, commentId));

export const deleteComment = async (
	data: CommentDTO,
	id: number,
): Promise<Comment> => axiosRequest(endpoints.comments.deleteComment(data, id));

// FILE UPLOAD

export const uploadFile = async (data: FormData) =>
	axiosRequest(endpoints.utils.uploadFile(data));

// QUIZ
export const getQuizBySlug = async (slug: string) =>
	axiosRequest(endpoints.quiz.getQuizBySlug(slug));

// CODE TASKS
export const getCodeTaskBySlug = async (slug: string) =>
	axiosRequest(endpoints.codeTasks.getCodeTaskBySlug(slug));

export const createUserCodeTask = async (payload: ICodeTaskDTO) =>
	axiosRequest(endpoints.codeTasks.createUserCodeTask(payload));

// PRODUCTS

export const getAllProducts = async () =>
	axiosRequest(endpoints.products.getAllProducts());

export const getProductBySlug = async (slug: string) =>
	axiosRequest(endpoints.products.getProductBySlug(slug));

// ORDERS

export const createOrder = async (data: FormData): Promise<IOrder> =>
	axiosRequest(endpoints.orders.createOrder(data));

export const getOrderByNumber = async (orderNumber: number) =>
	axiosRequest(endpoints.orders.getOrderByNumber(orderNumber));
